/**
 * Module: ADVANCED-SEARCH
 * Description: TBD
 * Version: 3.0.2020.07231
 */

import { A11yModule } from "@angular/cdk/a11y";
import { OverlayModule } from "@angular/cdk/overlay";
import { PortalModule } from "@angular/cdk/portal";
import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { GoogleMapsModule } from "@angular/google-maps";
import { NoopAnimationsModule } from "@angular/platform-browser/animations";

import { SharedLibraryModule } from "../shared-library/shared-library.module";

import { AdvancedSearchComponent } from "./advanced-search.component";
import { DirectorySearchComponent } from "./modules/directory-search/directory-search.component";
import { ContentSearchComponent } from "./modules/content-search/content-search.component";
import { TabsLandingComponent } from "./components/tabs-landing/tabs-landing.component";
import { DirectorySearchFiltersComponent } from "./modules/directory-search/components/directory-search-filters/directory-search-filters.component";
import { DirectorySearchResultsListComponent } from "./modules/directory-search/components/directory-search-results-list/directory-search-results-list.component";
import { DirectoryItemComponent } from "./modules/directory-search/components/directory-item/directory-item.component";
import { GoogleMapComponent } from "./modules/directory-search/components/google-map/google-map.component";
import { MultipleChoiceFacetComponent } from "./form-controls/multiple-choice-facet/multiple-choice-facet.component";
import { CalendarFilterComponent } from "./modules/directory-search/components/calendar-filter/calendar-filter.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import {RecommendedLinksComponent} from "./components/recommended-links/recommended-links.component";

@NgModule({
    declarations: [
        AdvancedSearchComponent,
        ContentSearchComponent,
        DirectoryItemComponent,
        DirectorySearchComponent,
        DirectorySearchFiltersComponent,
        DirectorySearchResultsListComponent,
        GoogleMapComponent,
        MultipleChoiceFacetComponent,
        TabsLandingComponent,
        CalendarFilterComponent,
        RecommendedLinksComponent,
    ],
    imports: [
        A11yModule,
        CommonModule,
        GoogleMapsModule,
        MatDatepickerModule,
        MatMomentDateModule,
        NoopAnimationsModule,
        OverlayModule,
        PortalModule,
        ReactiveFormsModule,
        SharedLibraryModule
    ],
    providers: [
        DatePipe
    ]
})
export class AdvancedSearchModule {
}
